import { useState, useEffect } from 'react';
import { postData } from '../../../../../ApiServices/ApiService';
import { ORG_INVOICE } from '../../../../../ApiServices/BaseURL';

const InvoiceOtherSettingsController = (bookOpenBalance, overdueDays, errorSettings, onRefresh) => {
    const [booksOpeningBalance, setBooksOpeningBalance] = useState(0);
    const [overdueSetting, setOverdueSetting] = useState(0);
    const [isEditingBooksOpening, setIsEditingBooksOpening] = useState(false);
    const [isEditingOverdue, setIsEditingOverdue] = useState(false);
    const [openingBalanceError, setOpeningBalanceError] = useState("");
    const [openingBalanceSuccess, setOpeningBalanceSuccess] = useState("");
    const [openingBalanceLoading, setOpeningBalanceLoading] = useState("");
    const [overdueError, setOverdueError] = useState("");
    const [overdueSuccess, setOverdueSuccess] = useState("");
    const [overdueLoading, setOverdueLoading] = useState("");
    const [bookOpenBalanceError, setBookOpenBalanceError] = useState("");
    const [overdueSettingError, setOverdueSettingError] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        setBooksOpeningBalance(bookOpenBalance);
        setOverdueSetting(overdueDays);
        setError(errorSettings);
    }, [bookOpenBalance, overdueDays, errorSettings]);

    const handleUpdateOpeningBalance = async () => {

        try {
            setOpeningBalanceError('');
            setOpeningBalanceSuccess('');
            setBookOpenBalanceError("");

            if (!booksOpeningBalance) {
                setBookOpenBalanceError("Please enter the books opening balance");
                return;
            }

            setOpeningBalanceLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "action": "OPENING_BAL_UPDATE",
                "acc_book_open_balance": booksOpeningBalance,
            }

            //console.log('handleUpdateTaskType Data', payLoad);
            // Make the API call
            const response = await postData(ORG_INVOICE, payLoad);
            const responseData = await response.json();
            //console.log('handleUpdateTaskType response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setOpeningBalanceSuccess(responseData?.info);
                        setTimeout(() => {
                            setOpeningBalanceSuccess('');
                            setIsEditingBooksOpening(false);
                            onRefresh();
                        }, 3000);
                    } else {
                        setOpeningBalanceError(responseData?.info || 'Failed to Update Task Type data. Please try again.');
                    }
                } else {
                    setOpeningBalanceError(responseData?.info || 'Failed to Update Task Type data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setOpeningBalanceError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setOpeningBalanceError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setOpeningBalanceError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setOpeningBalanceError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setOpeningBalanceError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setOpeningBalanceError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setOpeningBalanceError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setOpeningBalanceLoading(false);
        }


        // onValueChange(clientData); // Send data to Dashboard
        // onClose(); // Close modal
    };

    const handleUpdateOverDue = async () => {

        try {
            setOverdueError('');
            setOverdueSuccess('')
            setOverdueSettingError("");

            if (!overdueSetting) {
                setOverdueSettingError("Please enter the overdue setting");
                return;
            }

            if (!/^\d+$/.test(overdueSetting)) {
                setOverdueSettingError("Overdue setting must be a whole number");
                return;
            }
            setOverdueLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "action": "OVERDUE_DAYS_UPDATE",
                "acc_overdue_days": overdueSetting,
            }

            //console.log('handleUpdateTaskType Data', payLoad);
            // Make the API call
            const response = await postData(ORG_INVOICE, payLoad);
            const responseData = await response.json();
            //console.log('handleUpdateTaskType response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setOverdueSuccess(responseData?.info);
                        setTimeout(() => {
                            setOverdueSuccess('');
                            setIsEditingOverdue(false);
                            onRefresh();
                        }, 3000);
                    } else {
                        setOverdueError(responseData?.info || 'Failed to Update Task Type data. Please try again.');
                    }
                } else {
                    setOverdueError(responseData?.info || 'Failed to Update Task Type data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setOverdueError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setOverdueError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setOverdueError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setOverdueError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setOverdueError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setOverdueError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setOverdueError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setOverdueLoading(false);
        }


        // onValueChange(clientData); // Send data to Dashboard
        // onClose(); // Close modal
    };

    return {
        booksOpeningBalance,
        setBooksOpeningBalance,
        overdueSetting,
        setOverdueSetting,
        isEditingBooksOpening,
        isEditingOverdue,
        handleUpdateOpeningBalance,
        handleUpdateOverDue,
        openingBalanceError,
        openingBalanceSuccess,
        openingBalanceLoading,
        overdueError,
        overdueSuccess,
        overdueLoading,
        setIsEditingBooksOpening,
        setIsEditingOverdue,
        bookOpenBalanceError,
        overdueSettingError,
        error,
    };
};

export default InvoiceOtherSettingsController;
